export const dashboard = {
  overview: 'Vue d\'ensemble',
  vehicles: 'Véhicules',
  clients: 'Clients',
  bookings: 'Réservations',
  calendar: 'Calendrier',
  contracts: 'Contrats',
  invoices: 'Factures et Paiements',
  reports: 'Rapports',
  settings: 'Paramètres',
  agencySettings: 'Paramètres de l\'agence',
  profileSettings: 'Paramètres du profil',
  agencyPanel: 'Panneau d\'agence',
  agency: 'Agence',
  noAgency: 'Aucune Agence Trouvée',
  createAgencyFirst: 'Vous devez d\'abord créer une agence pour accéder au tableau de bord.',
  createAgency: 'Créer une Agence',
  
  // Overview
  activeRentals: 'Locations Actives',
  availableVehicles: 'Véhicules Disponibles',
  totalClients: 'Total des Clients',
  pendingPayments: 'Paiements en Attente',
  monthlyRevenue: 'Revenus Mensuels',
  yearlyRevenue: 'Revenus Annuels',
  upcomingPickups: 'Prises en Charge à Venir',
  upcomingReturns: 'Retours à Venir',
  totalVehicles: 'Total des Véhicules',
  notifications: 'Notifications et Alertes',
  quickActions: 'Actions Rapides',
  addVehicle: 'Ajouter un Véhicule',
  addVehicleDesc: 'Ajouter un nouveau véhicule à votre flotte',
  newBooking: 'Nouvelle Réservation',
  newBookingDesc: 'Créer une nouvelle réservation de location',
  addClient: 'Ajouter un Client',
  addClientDesc: 'Ajouter un nouveau client à votre base de données',
  upcomingPickupsMessage: 'Vous avez {{count}} prises en charge à venir cette semaine',
  upcomingReturnsMessage: 'Vous avez {{count}} retours à venir cette semaine',
  pendingPaymentsMessage: 'Vous avez {{count}} paiements en attente à collecter',
  
  // Empty states
  noCarsYet: 'Aucun véhicule pour le moment',
  noCarsYetDesc: 'Vous n\'avez pas encore ajouté de véhicules à votre flotte. Ajoutez votre premier véhicule pour commencer à gérer votre entreprise de location.',
  addFirstVehicle: 'Ajouter Votre Premier Véhicule',
  addFirstVehicleMessage: 'Commencez par ajouter votre premier véhicule',
  welcomeToAgency: 'Bienvenue dans votre tableau de bord d\'agence !',
  
  // Setup steps
  step1: 'Étape 1',
  step1Desc: 'Ajoutez vos véhicules avec photos et détails',
  step2: 'Étape 2',
  step2Desc: 'Configurez vos tarifs et disponibilités',
  step3: 'Étape 3',
  step3Desc: 'Commencez à recevoir des réservations',
  
  // Dashboard overview
  activityOverview: 'Aperçu de votre activité et indicateurs clés',
  newContract: 'Nouveau contrat',
  vehiclePlanning: 'Planning des véhicules',
  statisticsAnalytics: 'Statistiques et analyses',
  detailedAnalysis: 'Analyse détaillée de vos performances et indicateurs clés',
  vehicleStatus: 'État des véhicules',
  bookingStatus: 'État des réservations',
  categoryPerformance: 'Performance par catégorie',
}; 